<div data-cy="error-list-banner" *ngIf="errors.length > 0" id="error-list-banner" tabindex="-1">
  <omgui-banner type="DangerLight" [dismissible]="false" aria-live="assertive">
    <div class="d-flex align-items-center">
      <om-svg-info alt="" class="me-2" aria-hidden="true"></om-svg-info>
      <div class="d-flex flex-column mx-2 text-start gap-2">
        <p class="mb-0 small">{{ heading }} </p>
        <ol class="errors-list" *ngFor="let err of errors" tabindex="0">
          <li class="error-message">
            <a class="error-messages-link" [href]="err?.href">{{ err?.message }}</a>
          </li>
        </ol>
      </div>
    </div>
  </omgui-banner>
</div>
